import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  EditButton,
  Filter,
  Resource,
} from "react-admin";

// Server-side search: the value goes out as ?search= (see dataProvider getList) and
// the backend filters by material group / process name (ILIKE).
const ProcessApplicabilityFilters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
);

// Rule 14 matrix ("Finishings/Processes Allowed"): material group × process
// (Dye/Print/Treatment/Raw) with an `allowed` flag. Editable in place — toggling
// `allowed` changes which materials produce an INVALID_VALUE gap on the NEXT
// completeness job run (it does not recalculate retroactively).
const ProcessApplicabilityList = (props) => (
  <List {...props} perPage={100} bulkActionButtons={false} filters={<ProcessApplicabilityFilters />}>
    <div style={{ marginTop: "15px" }}>
      <Datagrid rowClick="edit">
        <TextField source="materialGroup" label="Material group" />
        <TextField source="process" label="Process" />
        <BooleanField source="allowed" label="Allowed" />
        <EditButton />
      </Datagrid>
    </div>
  </List>
);

const EditProcessApplicability = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="materialGroup" label="Material group" disabled />
      <TextInput source="process" label="Process" disabled />
      <BooleanInput source="allowed" label="Allowed" />
    </SimpleForm>
  </Edit>
);

const processApplicabilityResource = () => (
  <Resource
    name="processApplicability"
    options={{ label: "Process applicability", menuGroup: "Bcome" }}
    list={ProcessApplicabilityList}
    edit={EditProcessApplicability}
  />
);

export default processApplicabilityResource;
